import React from 'react'
import AddSvg from '../../../../assets/icons/add.svg'
import './Header.scss'

function Header ({ title, subtitle, disabledBtn1, btnTitle1, onClickBtn1, iconBtn1=AddSvg, disabledBtn2, btnTitle2, onClickBtn2, iconBtn2, disabledBtn3, btnTitle3, onClickBtn3, iconBtn3  }) {
  return (
    <>
      <h2 className='header-title'>{title}</h2>
      <div className='header-container'>
        <p>{subtitle}</p>
        <div className='header-btncontainer'>
          {
            btnTitle2 &&
            <div onClick={onClickBtn2} className={disabledBtn2 ? 'header-disabled btn2' : 'btn2'}>
              {iconBtn2 && <img src={iconBtn2} alt='agregar' />}
              <p>{btnTitle2}</p>
            </div>
          }
          {
            btnTitle1 &&
            <div onClick={onClickBtn1} className={disabledBtn1 ? 'header-disabled' : null}>
              {iconBtn1 && <img src={iconBtn1} alt='agregar' />}
              <p>{btnTitle1}</p>
            </div>
          }
          {
            btnTitle3 &&
            <div onClick={onClickBtn3} className={disabledBtn3 ? 'header-disabled' : 'btn3'}>
              {iconBtn3 && <img src={iconBtn3} alt='agregar' />}
              <p>{btnTitle3}</p>
            </div>
          }
        </div>
      </div>
    </>
  )
}

export default Header
